const HANDLE_BODY_REGEX = /^[a-z0-9][a-z0-9._-]*[a-z0-9]$|^[a-z0-9]{2}$/i;

export function normalizeHandleInput(raw) {
  let value = String(raw || '').trim();
  if (!value.startsWith('@')) value = value ? `@${value}` : '@';
  return value;
}

export function stripHandlePrefix(raw) {
  return String(raw || '').trim().replace(/^@+/, '');
}

export function validateHandleInput(raw) {
  const body = stripHandlePrefix(raw).toLowerCase();
  if (!body) return { ok: false, message: 'Handle is required' };
  if (body.length < 2 || body.length > 32) {
    return { ok: false, message: 'Handle must be 2–32 characters (without @)' };
  }
  if (!HANDLE_BODY_REGEX.test(body)) {
    return {
      ok: false,
      message: 'Use letters, numbers, and . _ - only. Must start and end with a letter or number.',
    };
  }
  return { ok: true, normalized: body, display: `@${body}` };
}

export function displayNameFromSuggestion(handle) {
  const body = stripHandlePrefix(handle);
  if (!body) return '';
  return body
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}
